export interface IListItem {
	text: string;
	value: string;
}

export class ListItem implements IListItem {
	text: string;
	value: string;

	constructor() {
		this.text = null;
		this.value = null;
	}
}

export class LookupModel {
	items: ListItem[];

	constructor() {
		this.items = new Array<ListItem>();
	}
}